/**
 * Handle setting a browser cookie.
 */
// eslint-disable-next-line max-params
export default function setCookie(
  cookieName: string,
  cookieValue: string,
  expireDays?: number,
  sameSite?: 'Strict' | 'Lax' | 'None',
  secure?: boolean
) {
  const date = new Date();

  date.setTime(date.getTime() + ((expireDays || 365) * 24 * 60 * 60 * 1000));

  const expires = `expires=${date.toUTCString()}`;

  let cookieString = `${cookieName}=${cookieValue}; ${expires}; path=/`;

  if (sameSite) {
    cookieString += `; SameSite=${sameSite}`;
  }

  if (secure) {
    cookieString += '; Secure';
  }

  document.cookie = cookieString;
}
